/* ════════════════════════════════════════════════════════════════════════
   KILIM — FILTRES DE COLLECTION
   Chargé par sections/collection-etal.liquid. Le panneau s'ouvre et se
   ferme par assets/kilim-mouvement.js ; ici, on ne fait que trier.

   Chaque pièce de la grille porte ses valeurs (`data-matiere`, `data-geste`,
   `data-pour`, `data-poids`). Dans un groupe, les cases s'additionnent (OU) ;
   entre deux groupes, elles se cumulent (ET). Le compte de chaque case est
   celui qu'on obtiendrait en la cochant : une case à zéro est grisée, jamais
   un piège qui vide la grille.

   Un groupe qui n'offre pas au moins deux choix dans cette collection est
   masqué — la matière dans « Hijab jersey », par exemple. S'il ne reste
   aucun groupe, ou si la collection compte moins de cinq pièces, le bouton
   « Filtrer » ne s'affiche pas.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  var filtres = document.getElementById('filtres');
  var panneau = document.querySelector('.filtres__panneau');
  var pieces = Array.prototype.slice.call(document.querySelectorAll('.piece-filtrable'));
  /* Sous cinq pièces, on voit tout d'un coup d'œil : filtrer n'apporte rien. */
  if (!filtres || !panneau || pieces.length < 5) return;

  var groupes = Array.prototype.slice.call(panneau.querySelectorAll('[data-groupe]'));
  var compteBarre = document.querySelector('.facettes__compte .nombre');
  var libelleBarre = document.querySelector('.facettes__compte');
  var compteBouton = panneau.querySelector('[data-compte]');
  var actifs = filtres.querySelector('.filtres__actifs');

  function valeurs(piece, cle) {
    var v = piece.getAttribute('data-' + cle);
    return v ? v.split(' ') : [];
  }

  function selection() {
    var sel = {};
    groupes.forEach(function (g) {
      var coches = Array.prototype.map.call(
        g.querySelectorAll('input:checked'), function (i) { return i.value; });
      if (coches.length) sel[g.dataset.groupe] = coches;
    });
    return sel;
  }

  function retenue(piece, sel, sauf) {
    return Object.keys(sel).every(function (cle) {
      if (cle === sauf) return true;
      var v = valeurs(piece, cle);
      return sel[cle].some(function (x) { return v.indexOf(x) !== -1; });
    });
  }

  /* Au chargement : ne garder que les cases qui trient quelque chose ici. */
  var utiles = 0;
  groupes.forEach(function (g) {
    var cle = g.dataset.groupe, offertes = 0;
    Array.prototype.forEach.call(g.querySelectorAll('li'), function (li) {
      var val = li.querySelector('input').value;
      var n = pieces.filter(function (p) { return valeurs(p, cle).indexOf(val) !== -1; }).length;
      li.hidden = n === 0;
      if (n > 0) offertes++;
    });
    g.hidden = offertes < 2;
    if (!g.hidden) utiles++;
  });
  if (!utiles) return;
  filtres.hidden = false;

  function appliquer() {
    var sel = selection();
    var n = 0;
    pieces.forEach(function (p) {
      var ok = retenue(p, sel, null);
      p.hidden = !ok;
      if (ok) n++;
    });

    groupes.forEach(function (g) {
      var cle = g.dataset.groupe;
      Array.prototype.forEach.call(g.querySelectorAll('li'), function (li) {
        var input = li.querySelector('input');
        var c = pieces.filter(function (p) {
          return retenue(p, sel, cle) && valeurs(p, cle).indexOf(input.value) !== -1;
        }).length;
        li.querySelector('.filtres__n').textContent = c;
        input.disabled = c === 0 && !input.checked;
      });
    });

    if (compteBouton) compteBouton.textContent = n > 1 ? 'Voir les ' + n + ' pièces' : 'Voir la pièce';
    if (compteBarre) {
      compteBarre.textContent = n;
      libelleBarre.lastChild.textContent = n > 1 ? ' pièces' : ' pièce';
    }
    var total = Object.keys(sel).reduce(function (t, k) { return t + sel[k].length; }, 0);
    if (actifs) actifs.textContent = total ? ' (' + total + ')' : '';
  }

  panneau.addEventListener('change', appliquer);
  var vider = panneau.querySelector('.filtres__vider');
  if (vider) vider.addEventListener('click', function () {
    Array.prototype.forEach.call(panneau.querySelectorAll('input:checked'), function (i) { i.checked = false; });
    appliquer();
  });

  appliquer();
})();
